interface ContactBlock {
  icon: string;
  title: string;
  lines: { text: string; href?: string }[];
  note: string;
  directionsUrl?: string;
}

const contactBlocks: ContactBlock[] = [
  {
    icon: 'ri-phone-line',
    title: 'Teléfonos',
    lines: [
      { text: '+506 8322-2424', href: 'tel:+50683222424' },
      { text: '+506 2260-6629', href: 'tel:+50622606629' },
    ],
    note: 'Para consultas y coordinación de citas.',
  },
  {
    icon: 'ri-mail-line',
    title: 'Correo electrónico',
    lines: [{ text: 'leferasa@hotmail.com', href: 'mailto:leferasa@hotmail.com' }],
    note: 'Por favor indique su nombre, medio de contacto y una descripción general.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Ubicación',
    lines: [{ text: 'Heredia, 75 metros al oeste de Correos de Costa Rica' }],
    note: '',
    directionsUrl: 'https://www.google.com/maps/dir/?api=1&destination=75%20m%20Oeste%20Correos%20de%20Costa%20Rica%2C%20Heredia%2C%20Costa%20Rica',
  },
  {
    icon: 'ri-time-line',
    title: 'Horario',
    lines: [
      { text: 'Lunes a viernes, 7:30 a. m. – 6:00 p. m.' },
      { text: 'Sábados con cita previa' },
    ],
    note: '',
  },
];

export default function ContactInfo() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {contactBlocks.map((block) => (
          <div key={block.title} className="rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-9 h-9 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                <i className={`${block.icon} text-lg`}></i>
              </span>
              <div className="font-heading text-lg font-semibold text-foreground-950">{block.title}</div>
            </div>
            <div className="space-y-1">
              {block.lines.map((line) => (
                <div key={line.text} className="text-base text-foreground-950">
                  {line.href ? (
                    <a href={line.href} className="cursor-pointer">{line.text}</a>
                  ) : (
                    line.text
                  )}
                </div>
              ))}
            </div>
            {block.note && <div className="mt-3 text-sm text-foreground-600">{block.note}</div>}
            {block.directionsUrl && (
              <a
                href={block.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-foreground-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-route-line text-base"></i>
                Cómo llegar
              </a>
            )}
          </div>
        ))}
      </div>
      <div className="mt-8 rounded-lg border border-background-200 overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.216976997332!2d-84.1182338!3d9.998928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0fb9289fcd6b3%3A0xff4fd86c3afdd6b1!2sBufete%20Ramos%20Santos!5e0!3m2!1ses!2scr!4v1791939272416!5m2!1ses!2scr"
          title="Ubicación de Bufete Ramos Santos en Heredia, Costa Rica"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
    </>
  );
}